import AuthCardLayout from 'layouts/AuthCardLayout';
import BrokerSignUpForm from 'components/modules/auth/BrokerSignUpForm';

const BrokerSignUp = () => {
  return (
    <AuthCardLayout>
      <BrokerSignUpForm />
    </AuthCardLayout>
  );
};

export default BrokerSignUp;